import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { videoDurationOverlayVideo$key } from "~/queries/__generated__/videoDurationOverlayVideo.graphql";

import type { StyledProps } from "./styles";
import { Container, Duration, Icon } from "./styles";

type Props = {
  reference: videoDurationOverlayVideo$key;
} & PropsFromStyledProps<StyledProps>;

export const VideoDurationOverlay: FunctionComponent<Props> = ({
  reference: reference_,
  responsiveVariants,
}) => {
  const video = useFragment(
    graphql`
      fragment videoDurationOverlayVideo on Video {
        duration
      }
    `,
    reference_,
  );

  return (
    <Container $responsiveVariants={responsiveVariants}>
      <Icon /> <Duration>{video.duration}</Duration>
    </Container>
  );
};
